<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue';

const {
  needRefresh,
  offlineReady,
  updateServiceWorker,
} = useRegisterSW();

async function close() {
  offlineReady.value = false;
  needRefresh.value = false;
}
</script>

<template>
  <div class="notification is-success" role="alert" v-if="needRefresh || offlineReady">
    <button @click="close" class="delete" type="button" />
    <p>
      <span class="subtitle" v-if="offlineReady">
        Seu app está pronto para uso offline!
      </span>
      <span class="subtitle" v-if="needRefresh">
        Nova atualização disponivel!
        <br>
      </span>
    </p>
    <button @click="updateServiceWorker()" class="button is-light is-fullwidth" type="button" v-if="needRefresh">
      Recarregar página
    </button>
  </div>
</template>

<style>
.notification {
  position: fixed !important;
  right: 20px;
  top: 20px;
  width: 30%;
  z-index: 99;
}
</style>
